import { render } from "./Tyres.vue?vue&type=template&id=7c418783&scoped=true"
import script from "./Tyres.vue?vue&type=script&lang=js"
export * from "./Tyres.vue?vue&type=script&lang=js"

import "./Tyres.vue?vue&type=style&index=0&id=7c418783&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c418783"]])

export default __exports__